module.exports = __webpack_public_path__ + "img/tfb.9add5e77.png";